import type { DeviceFragment } from '@cobliteam/api-lib/src/__generated__/graphql';
import type { DeviceDelay } from '@cobliteam/common-types';
import type { StateCreator } from 'zustand';
import type { MonitoringSlices } from '.';

export type RealtimeConnectionStatus = 'connected' | 'reconnecting';

export interface DeviceSlice {
  currentDevice: DeviceFragment | undefined;
  deviceToReset: DeviceFragment | undefined;
  deviceStatusAndDelay: DeviceDelay | undefined;
  realtimeConnectionStatus: RealtimeConnectionStatus;
  setCurrentDevice: (device: DeviceFragment) => void;
  setDeviceToReset: (device: DeviceFragment | undefined) => void;
  setDeviceStatusAndDelay: (deviceStatusAndDelay: DeviceDelay | undefined) => void;
  setRealtimeConnectionStatus: (status: RealtimeConnectionStatus) => void;
}

type StateCreatorDevice = StateCreator<MonitoringSlices, [['zustand/devtools', never]], [], DeviceSlice>;

const createDeviceSlice: StateCreatorDevice = (set) => ({
  currentDevice: undefined,
  deviceStatusAndDelay: undefined,
  deviceToReset: undefined,
  realtimeConnectionStatus: 'connected',
  setCurrentDevice: (device) => set({ currentDevice: device }),
  setDeviceToReset: (device) => set({ deviceToReset: device }),
  setDeviceStatusAndDelay: (deviceStatusAndDelay) => set({ deviceStatusAndDelay }),
  setRealtimeConnectionStatus: (realtimeConnectionStatus) => set({ realtimeConnectionStatus }),
});

export default createDeviceSlice;
